// extracted by mini-css-extract-plugin
module.exports = {"backgroundGradient":"kn","cta":"ko","highlightedContentWrapper":"kp","tileSlideWrapper":"kq","infoWrapper":"kr","header":"ks","description":"kt"};